import axios from "axios";

const storage = sessionStorage;

export const SessionStore = {


  getSessionKey: () => {
    return storage.getItem(process.env.REACT_APP_SESSION_TOKEN);
  }
  ,
  setSessionKey: (token) => {
    if (token) {
      storage.setItem(process.env.REACT_APP_SESSION_TOKEN, token);
      axios.defaults.headers.common['Authorization'] = token;
    }
    else {
      storage.removeItem(process.env.REACT_APP_SESSION_TOKEN);
      delete axios.defaults.headers.common['Authorization'];
    }
  }
}
